
import { Breadcrumbs, CommonSelect } from "components/Common/Common";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { genericFormErrorMsg } from "utils/validation/validationHelpers";
import { Col, Container, Form, Row } from "react-bootstrap";

import styles from './profile.module.scss';
import { FieldArray, Formik } from "formik";
import { GRADE_OPTIONS } from "config/constants";
import { cloneDeep, isEmpty } from "lodash";
import { useEffect, useMemo, useState } from "react";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { successMessageToast } from "helpers/common";
import { useLazyAssignedSchoolsLookupQuery } from "store/services/utility";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import AppInputFieldV2 from "components/Common/AppInputFIeldV2";
import { TASK_PLAN } from "config/paths";
import { useNavigate, useParams } from "react-router-dom";
import { useGetSupportStaffClientsQuery } from "store/services/V2/supportStaff";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useGetTaskPlanSchoolClientsQuery, useUpdateTaskPlanMutation, useViewTaskPlanQuery } from "store/services/V2/TaskPlan";
import moment from "moment";
import TaskPlanTemplatesPopup from "components/Modals/TaskPlanTemplates";
import taskPlanEditSchema from "./taskPlanEdit.schema";
import { TaskPlanStrategyForm } from "components/shared/TaskPlan/TaskPlanStrategyForm";

const EditTaskPlan = () => {
    const Navigate = useNavigate()
    const { id } = useParams()
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const [schoolOptions, setSchoolOptions] = useState([]);
    const [getSchools] = useLazyAssignedSchoolsLookupQuery()

    const {
        data: taskPlanView,
        isLoading: taskPlanViewLoading,
        isError: taskPlanViewError,
        isFetching: taskPlanViewFetching
    } = useViewTaskPlanQuery({ id }, { skip: !id });

    const planClientType = taskPlanView?.client_type === "home_education" || (!taskPlanView?.school && taskPlanView?.client)
        ? "home_education"
        : "school";

    const { data: supportClientList } = useGetSupportStaffClientsQuery({
        plan_client_type: planClientType === "home_education" ? "home_education" : ""
    })
    const { data: taskSchoolClients } = useGetTaskPlanSchoolClientsQuery(
        { schoolId: taskPlanView?.school?.id },
        { skip: planClientType !== "school" || !taskPlanView?.school?.id }
    )

    const [updateTaskPlan, { isLoading: updateTaskPlanLoading }] = useUpdateTaskPlanMutation()


    const getSchoolOptions = async (search) => {
        try {

            const result = await getSchools(search);
            if (result?.data?.[0]?.id) {
                const data = result?.data?.map((item) => ({ label: item?.name, value: item?.id }))
                setSchoolOptions(data);
            }
        } catch (error) { console.error("Error Getting school options"); };

    };

    useEffect(() => {
        getSchoolOptions()
    }, [id])

    const emptyTask = {
        task_title: "",
        description: "",
        // date: "",
        strategy: null,
    }

    const initialValues = useMemo(() => {
        return {
            client_type: planClientType,
            school: taskPlanView?.school
                ? {
                    label: taskPlanView?.school?.name,
                    value: taskPlanView?.school?.id
                }
                : "",

            support_staffs: [
                {
                    value: taskPlanView?.support_staff?.id,
                    label: `${taskPlanView?.support_staff?.firstname} ${taskPlanView?.support_staff?.lastname}`
                },
            ],
            clients: [
                {
                    grade: {
                        label: taskPlanView?.client_grade,
                        value: taskPlanView?.client_grade,
                    },
                    client_id: {
                        value: taskPlanView?.client?.id,
                        label: `${taskPlanView?.client?.client_detail?.firstname} ${taskPlanView?.client?.client_detail?.lastname}`
                    },
                }
            ],

            // clients: taskPlanView?.clients?.length
            //     ? taskPlanView.clients.map((item) => ({
            //         grade: item.grade
            //             ? {
            //                 label: item?.grade,
            //                 value: item?.grade
            //             }
            //             : "",

            //         client_id: item.client
            //             ? {
            //                 value: item?.client.id || "",
            //                 label: `${item.client.client_detail.firstname} ${item.client.client_detail.lastname}` || ""
            //             }
            //             : null
            //     }))
            //     : [{ grade: "", client_id: null }],

            date: moment(taskPlanView?.date).format("YYYY-MM-DD"),
            plan_name: taskPlanView?.plan_name || "",
            tasks: taskPlanView?.tasks?.length
                ? taskPlanView.tasks.map((tsk) => ({
                    task_title: tsk?.task_name || "",
                    description: tsk?.task_description || "",
                    id: tsk?.id || "",
                    attachments: tsk?.attachments || [],
                    strategy: tsk.strategy || []
                }))
                : [emptyTask],

            start_date: taskPlanView?.start_date || "",
            end_date: taskPlanView?.end_date || "",
            no_of_sessions: taskPlanView?.no_of_sessions || ""
        };
    }, [taskPlanView, selectedTemplate, planClientType]);

    const handleSubmit = async (payload) => {
        try {
            const values = cloneDeep(payload);

            const formattedTasks = values?.tasks?.map((task) => {
                const { strategy, ...rest } = task;

                const formattedStrategy = strategy?.map((item) => ({
                    ...item,
                    template_id: item?.template_id?.toString(),
                    stragety_id: item?.stragety_id || "",
                    title: item?.title || "",
                    strategyRadio: item?.strategyRadio || "",
                    attachments: item?.attachments || [],
                    stragety_id: item?.title || "",

                }));

                return strategy
                    ? { ...rest, strategy: formattedStrategy }
                    : { ...rest };
            });


            const finalPayload = {
                date: moment(values?.date).format("YYYY-MM-DD"),
                plan_name: values?.plan_name || "",
                no_of_sessions: values?.no_of_sessions || "",
                tasks: formattedTasks
            };

            const result = await updateTaskPlan({ values: finalPayload, id }).unwrap()
            if (result.error) return;
            if (result.status === "success") {
                successMessageToast(result?.message);
                Navigate(TASK_PLAN)
            }

        } catch (err) { console.error("Error updating profile", err); }
    };


    return (
        <>
            <div className="px-3 py-2">
                <Breadcrumbs items={[{ label: "Task Plans", path: "/client/task-plan" }, { label: `Edit Task`, path: "" }]} style={{ fontSize: "14px" }} />


                <TaskPlanTemplatesPopup
                    showPopup={showTemplateModal}
                    setShowPopup={setShowTemplateModal}
                    onSelectTemplate={(template) => {
                        setSelectedTemplate(template)

                    }}
                    closePopup={() => setShowTemplateModal(false)} />
                <section className={`${styles.addForm} position-relative col-lg-10 addForm`}>
                    <Container fluid={true}>
                        {(taskPlanViewLoading) ? <LoadingIndicator /> : <Row>
                            {(taskPlanViewFetching) && <LoadingOverlay />}

                            <Col lg="12" className="my-2 px-0 ">
                                {taskPlanViewError ? (
                                    <ErrorComponent />
                                ) : (
                                    <Formik
                                        initialValues={initialValues}
                                        validationSchema={taskPlanEditSchema}
                                        onSubmit={handleSubmit}
                                        enableReinitialize
                                    >
                                        {({
                                            handleSubmit,
                                            errors,
                                            submitCount,
                                            values,
                                            setFieldValue,
                                            touched
                                        }) => {
                                            const selectedStaffIds = values.support_staffs
                                                ?.map(s => s.staff_id?.value)
                                                ?.filter(Boolean);

                                            const selectedClientIds = values.clients
                                                ?.map(c => c.client_id?.value)
                                                ?.filter(Boolean);

                                            return (
                                                <Form onSubmit={handleSubmit}>
                                                    <div
                                                    >
                                                        <Col lg="12" className="mb-2">
                                                            <div className=' d-flex align-items-end justify-content-between'>
                                                                <h5 className='section-title-main fw-medium border-0 m-0 p-0'>
                                                                    Edit a Task Plan</h5>
                                                                {/* <CommonButton
                                                                    text="Choose from My Library"
                                                                    className="staff-button-outlined mt-3"
                                                                    onClick={() => setShowTemplateModal(true)}
                                                                /> */}
                                                            </div>
                                                        </Col>

                                                        <div className={styles.clientTypeTabs}>
                                                            <button
                                                                type="button"
                                                                disabled
                                                                className={values.client_type === "school" ? styles.activeTab : ""}
                                                            >
                                                                School Clients
                                                            </button>
                                                            <button
                                                                type="button"
                                                                disabled
                                                                className={values.client_type === "home_education" ? styles.activeTab : ""}
                                                            >
                                                                Home Education Clients
                                                            </button>
                                                        </div>

                                                        {values.client_type === "school" && (
                                                            <div style={{ marginTop: "15px" }}>
                                                                <h5 className="section-title">1.   CHOOSE A SCHOOL</h5>
                                                                <div className="d-flex flex-column gap-4 ps-md-3">
                                                                    <Row>
                                                                        <Col xs="8" lg="6">
                                                                            <div className="w-100 reports-v2 ">
                                                                                <label className="mb-1 fw-semibold" style={{ fontSize: "12px" }}>
                                                                                    School Name*
                                                                                </label>
                                                                                <CommonSelect
                                                                                    placeholder=""
                                                                                    value={values.school}
                                                                                    option={schoolOptions}
                                                                                    onChange={(val) => setFieldValue(`school`, val)}
                                                                                    isClearable
                                                                                    isFilterV2
                                                                                    name={"school"}
                                                                                    isDisabled={true}
                                                                                    className="bg-body-secondary"
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div style={{ marginTop: "34px" }}>
                                                            <h5 className="section-title">{values.client_type === "school" ? "2" : "1"}. CHOOSE SUPPORT STAFF</h5>

                                                            <div className="ps-md-3">
                                                                <FieldArray name="support_staffs">
                                                                    {({ push, remove }) => (
                                                                        <>
                                                                            {values.support_staffs?.map((staff, staffIndex) => (
                                                                                <Row key={staffIndex} className="mb-3">
                                                                                    <Col xs="8" lg="6">
                                                                                        <div className="w-100 reports-v2">
                                                                                            <label
                                                                                                className="mb-1 fw-semibold"
                                                                                                style={{ fontSize: "12px" }}
                                                                                            >
                                                                                                Support Staff*
                                                                                            </label>

                                                                                            <CommonSelect
                                                                                                name={`support_staffs.${staffIndex}`}
                                                                                                placeholder=""
                                                                                                isDisabled={true}
                                                                                                value={values.support_staffs[staffIndex].staff_id}
                                                                                                options={
                                                                                                    supportClientList
                                                                                                        ?.map(item => ({
                                                                                                            value: item.id,
                                                                                                            label: `${item.firstname} ${item.lastname ?? ""}`,
                                                                                                        }))
                                                                                                        ?.filter(option =>
                                                                                                            !selectedStaffIds.includes(option.value) ||
                                                                                                            option.value === values.support_staffs[staffIndex]?.staff_id?.value
                                                                                                        )
                                                                                                }
                                                                                                onChange={(val) =>
                                                                                                    setFieldValue(
                                                                                                        `support_staffs.${staffIndex}.staff_id`,
                                                                                                        val
                                                                                                    )
                                                                                                }
                                                                                                isClearable
                                                                                                isFilterV2
                                                                                                className="bg-body-secondary"
                                                                                            />
                                                                                        </div>
                                                                                    </Col>

                                                                                    {/* <Col sm="2" className="d-flex align-items-end ">
                                                                                        {staffIndex > 0 && (
                                                                                            <button
                                                                                                type="button"
                                                                                                className="bg-transparent border-0"
                                                                                                style={{ color: "#023843" }}
                                                                                                onClick={() => remove(staffIndex)}
                                                                                            >
                                                                                                <CrossIcon />
                                                                                            </button>
                                                                                        )}
                                                                                    </Col> */}
                                                                                </Row>
                                                                            ))}

                                                                            {/* <CommonButton
                                                                                text="Add Another"
                                                                                className="staff-button-filled mt-3"
                                                                                onClick={() =>
                                                                                    push({
                                                                                        staff_id: null,
                                                                                    })
                                                                                }
                                                                            /> */}
                                                                        </>
                                                                    )}
                                                                </FieldArray>
                                                            </div>
                                                        </div>


                                                        <div style={{ marginTop: "34px" }}>
                                                            <h5 className="section-title">{values.client_type === "school" ? "3" : "2"}.   CHOOSE CLIENT(S)</h5>
                                                            <div className="ps-md-3">
                                                                <FieldArray name="clients">
                                                                    {({ push, remove }) => (
                                                                        <>
                                                                            {values.clients && values.clients.length > 0 &&
                                                                                values.clients.map((client, clientIndex) => (
                                                                                    <Row key={clientIndex} className="mb-3">
                                                                                        <Col xs="2">
                                                                                            <div className="w-100 reports-v2">
                                                                                                <label className="mb-1 fw-semibold" style={{ fontSize: "12px" }}>
                                                                                                    Grade*
                                                                                                </label>

                                                                                                <CommonSelect
                                                                                                    name={`clients.${clientIndex}.grade`}
                                                                                                    placeholder=""
                                                                                                    value={values.clients[clientIndex].grade}
                                                                                                    options={GRADE_OPTIONS}
                                                                                                    onChange={(val) =>
                                                                                                        setFieldValue(`clients.${clientIndex}.grade`, val)
                                                                                                    }
                                                                                                    isClearable
                                                                                                    isFilterV2
                                                                                                    isDisabled={true}
                                                                                                    className="bg-body-secondary"
                                                                                                />
                                                                                            </div>
                                                                                        </Col>

                                                                                        <Col xs="6" xl="7">
                                                                                            <div className="w-100 reports-v2">
                                                                                                <label className="mb-1 fw-semibold" style={{ fontSize: "12px" }}>
                                                                                                    Name*
                                                                                                </label>

                                                                                                <CommonSelect
                                                                                                    isDisabled={true}
                                                                                                    name={`clients.${clientIndex}.client_id`}
                                                                                                    placeholder=""
                                                                                                    value={values.clients[clientIndex].client_id}
                                                                                                    options={
                                                                                                        taskSchoolClients
                                                                                                            ?.map(item => ({
                                                                                                                value: item.id,
                                                                                                                label: `${item.firstname} ${item.lastname}`,
                                                                                                            }))
                                                                                                            ?.filter(option =>
                                                                                                                !selectedClientIds.includes(option.value) ||
                                                                                                                option.value === values.clients[clientIndex]?.client_id?.value
                                                                                                            )
                                                                                                    }

                                                                                                    onChange={(val) =>
                                                                                                        setFieldValue(`clients.${clientIndex}.client_id`, val)
                                                                                                    }
                                                                                                    isClearable
                                                                                                    isFilterV2
                                                                                                    className="bg-body-secondary"
                                                                                                />
                                                                                            </div>
                                                                                        </Col>

                                                                                        {/* <Col md="2" className="d-flex align-items-end">
                                                                                            {
                                                                                                clientIndex > 0 &&
                                                                                                <button
                                                                                                    className=' bg-transparent border-0'
                                                                                                    style={{ color: "#023843" }} onClick={() => remove(clientIndex)}>
                                                                                                    <CrossIcon />
                                                                                                </button>
                                                                                            }

                                                                                        </Col> */}
                                                                                    </Row>
                                                                                ))}

                                                                            {/* <CommonButton
                                                                                text="Add Another"
                                                                                className="staff-button-outlined mt-3"
                                                                                onClick={() => {
                                                                                    push({
                                                                                        grade: "",
                                                                                        client_id: "",
                                                                                    })
                                                                                }}
                                                                            /> */}
                                                                        </>
                                                                    )}
                                                                </FieldArray>
                                                            </div>
                                                        </div>

                                                        <div style={{ marginTop: "34px" }}>
                                                            <div className="position-relative">
                                                                <h5 className="section-title mt-3">
                                                                    {values.client_type === "school" ? "4" : "3"}. PLAN
                                                                </h5>
                                                            </div>
                                                            <Row className='d-flex justify-content-between ps-md-3'>
                                                                <Col xs="9">
                                                                    <label className="discharge-screen-label">
                                                                        Plan Name*
                                                                    </label>
                                                                    <AppInputFieldV2
                                                                        name={`plan_name`}
                                                                        type="text"
                                                                        className="readonly-box"
                                                                    />
                                                                </Col>
                                                                <Col xs="3" xl="2" className='d-flex reports-v2'>
                                                                    <div className='' style={{ width: "145px" }}>
                                                                        <label className="discharge-screen-label">
                                                                            Date Created*
                                                                        </label>
                                                                        <AppDatePicker
                                                                            name={`date`}
                                                                            className="read-only w-100 py-2"
                                                                            popperPlacement="bottom-start"
                                                                            popperClassName="react-datepicker-popper"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                        </div>

                                                        <div style={{ marginTop: "34px" }}>
                                                            <h5 className="section-title mt-3">
                                                                {values.client_type === "school" ? "5" : "4"}. ADD TASK(S)
                                                            </h5>
                                                            <FieldArray name="tasks">
                                                                {({ push, remove }) => (
                                                                    <>
                                                                        {values?.tasks?.map((task, taskIndex) => {
                                                                            return (
                                                                                <div key={taskIndex} className="ps-md-3 mb-4 ">
                                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                                        <span className="fw-semibold text-secondary me-2">
                                                                                            {taskIndex + 1}.
                                                                                        </span>
                                                                                        {/* <div className="">
                                                                                            {values.tasks.length > 1 && taskIndex > 0 && (
                                                                                                <button
                                                                                                    className='bg-transparent border-0'
                                                                                                    style={{ color: "#023843" }} onClick={() => remove(taskIndex)}>
                                                                                                    <CrossIcon />
                                                                                                </button>
                                                                                            )}
                                                                                        </div> */}
                                                                                    </div>

                                                                                    <div className="">
                                                                                        <Row className='d-flex justify-content-between'>
                                                                                            <Col md="9">
                                                                                                <label className="discharge-screen-label">
                                                                                                    Task Name*
                                                                                                </label>
                                                                                                <AppInputFieldV2
                                                                                                    name={`tasks.${taskIndex}.task_title`}
                                                                                                    type="text"
                                                                                                    className="readonly-box"
                                                                                                />
                                                                                            </Col>

                                                                                        </Row>

                                                                                        <Col md="9" className="mt-3">
                                                                                            <label className="discharge-screen-label">
                                                                                                Task Description*
                                                                                            </label>
                                                                                            <p className='support-staff-text-head' style={{ fontWeight: 400 }}>Describe the task you want the student to work on. You will be able to update this description when the task is in progress.</p>
                                                                                            <CustomEditor
                                                                                                name={`tasks.${taskIndex}.description`}
                                                                                                attachmentName={`tasks.${taskIndex}.attachments`}
                                                                                            />
                                                                                        </Col>

                                                                                        <div className="staff-divider mt-4"></div>

                                                                                    </div>
                                                                                    <FieldArray name={`tasks.${taskIndex}.strategy`}>
                                                                                        {({ push: pushStrategy, remove: removeStrategy }) => (
                                                                                            <>
                                                                                                {values?.tasks?.[taskIndex]?.strategy?.map((strategy, strategyIndex) => (
                                                                                                    <div key={strategyIndex} className="mb-3 mt-5 position-relative">
                                                                                                        <TaskPlanStrategyForm
                                                                                                            taskIndex={taskIndex}
                                                                                                            strategyIndex={strategyIndex}
                                                                                                            setFieldValue={setFieldValue}
                                                                                                            values={values}
                                                                                                            remove={removeStrategy}
                                                                                                            clientType="task_plan"
                                                                                                            isEdit={true}
                                                                                                        />
                                                                                                    </div>
                                                                                                ))}

                                                                                                {/* {(values?.tasks?.[taskIndex]?.strategy?.length || 0) < 4 && (
                                                                                                    <div className="d-flex align-items-center gap-3 mt-3">
                                                                                                        <CommonButton
                                                                                                            className="staff-button-outlined"
                                                                                                            text="Add a Strategy"
                                                                                                            type="button"
                                                                                                            onClick={() =>
                                                                                                                pushStrategy({
                                                                                                                    text: "",
                                                                                                                    attachments: []
                                                                                                                })
                                                                                                            }
                                                                                                        />
                                                                                                    </div>
                                                                                                )} */}
                                                                                            </>
                                                                                        )}
                                                                                    </FieldArray>


                                                                                    {/* {task.strategy && (
                                                                                        <div className="my-3 position-relative">
                                                                                            <Col md="9">
                                                                                                <label className="discharge-screen-label">
                                                                                                    Strategy Text
                                                                                                </label>
                                                                                                <CustomEditor
                                                                                                    name={`tasks.${taskIndex}.strategy.text`}
                                                                                                    attachmentName={`tasks.${taskIndex}.strategy.attachments`}
                                                                                                />
                                                                                            </Col>

                                                                                            <button
                                                                                                className='position-absolute top-0 end-0 bg-transparent border-0'
                                                                                                style={{ color: "#023843" }}
                                                                                                onClick={() => {
                                                                                                    setFieldValue(`tasks.${taskIndex}.strategy`, null)
                                                                                                }}> <CrossIcon />
                                                                                            </button>

                                                                                        </div>
                                                                                    )} */}
                                                                                    {
                                                                                        taskIndex !== values.tasks.length - 1 && (
                                                                                            <div className="staff-divider mt-4"></div>
                                                                                        )
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        })}
                                                                        <div className="staff-divider my-4"></div>
                                                                        {/* <div className='d-flex align-items-center gap-3'>
                                                                            <CommonButton
                                                                                className="staff-button-filled"
                                                                                text="Add a Task"
                                                                                onClick={() => {
                                                                                    if (values.tasks.length < 4) {
                                                                                        push(emptyTask)
                                                                                    }
                                                                                }}
                                                                            />
                                                                            <span className='support-staff-description' style={{ color: "#071E3E", fontStyle: "italic" }}>
                                                                                Max. 4
                                                                            </span>
                                                                        </div> */}

                                                                    </>
                                                                )}
                                                            </FieldArray>
                                                        </div>
                                                        <div style={{ marginTop: "34px" }}>
                                                            <h5 className="section-title mt-5">
                                                                {values.client_type === "school" ? "6" : "5"}. SET FREQUENCY
                                                            </h5>

                                                            <Row className="ps-md-3 reports-v2">
                                                                <Col xs="3" xl="2">
                                                                    <label className="discharge-screen-label">
                                                                        Start Date
                                                                    </label>
                                                                    <AppDatePicker
                                                                        disabled={true}
                                                                        name={`start_date`}
                                                                        className="read-only w-100 py-2 bg-body-secondary"
                                                                        popperPlacement="bottom-start"
                                                                        popperClassName="react-datepicker-popper"
                                                                    />
                                                                </Col>

                                                                <Col xs="3" xl="2">
                                                                    <label className="discharge-screen-label">
                                                                        End Date
                                                                    </label>
                                                                    <AppDatePicker
                                                                        disabled={true}
                                                                        name={`end_date`}
                                                                        className="read-only w-100 py-2 bg-body-secondary"
                                                                        popperPlacement="bottom-start"
                                                                        popperClassName="react-datepicker-popper"
                                                                        minDate={values.start_date}
                                                                    />
                                                                </Col>

                                                                <Col xs="3" xl="2">
                                                                    <label className="discharge-screen-label">
                                                                        Number of Sessions
                                                                    </label>
                                                                    <AppInputFieldV2
                                                                        name="no_of_sessions"
                                                                        type="text"
                                                                        className="readonly-box"
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        {(!isEmpty(errors) && submitCount > 0) && (
                                                            <Row className="mt-4">
                                                                <Col lg="12">
                                                                    <span className="error">{genericFormErrorMsg}</span>
                                                                </Col>
                                                            </Row>
                                                        )}
                                                        <div className="d-flex justify-content-between mt-5">
                                                            <button type="button" onClick={() => Navigate(TASK_PLAN)} className="button-outlined ">Cancel  </button>

                                                            <button type="submit" className="button-filled ">{updateTaskPlanLoading ? <LoadingIndicator color="#fff" /> : 'DONE'}  </button>
                                                        </div>


                                                    </div>


                                                </Form>
                                            )
                                        }}
                                    </Formik>
                                )}
                            </Col>

                        </Row>}
                    </Container>
                </section>
            </div>
        </>
    );
};

export default EditTaskPlan;
